import React from "react";
import GroupingWidget from "./widget/GroupingWidget";
import {logAction} from "../../../logging/logEvent";
import {formatGroupName} from "./GroupingTranslator";
import ResponsiveLayout, {ResponsiveLayoutItem} from "./ResponsiveLayout";

const GroupingsLayout = ({
                             showAdditionalGroupings,
                             groupings,
                             currency,
                             kpiChooser,
                             companyId = null,
                             portfolioId,
                             portfolioName,
                             authorRanking,
                             companyRanking,
                             primaryGroup,
                             companyWithinPortfolioLinkGenerator,
                             getExploreUrlFor,
                             getExportUrlFor,
                             pageName,
                             programmeContext
                         }) => {
    function onViewClickFor(groupingName) {
        return () => {
            logAction({
                type: `GROUPING_EXPANDED`,
                groupingName: groupingName,
                portfolioId,
                portfolioName,
                companyId
            });
        }
    }

    function onExportClickFor(groupingName, url) {
        return () => {
            logAction({
                type: `GROUPING_EXPORTED`,
                groupingName: groupingName,
                ...programmeContext,
                exportUrl: url,
                pageName: pageName
            });
        }
    }


    const exploreUrlForCompany = getExploreUrlFor("author-company");
    const exportUrlForCompany = getExportUrlFor("author-company");
    const rankingsSelectedKpi = kpiChooser.selectedKpi({isAdditionalGrouping: false});
    const companyWidget = !companyRanking ? null : (
        <ResponsiveLayoutItem>
            <GroupingWidget className="t-company-grouping"
                            currency={currency}
                            selectedKpi={rankingsSelectedKpi}
                            grouping={companyRanking}
                            groupingName="author-company"
                            title="Author Company"
                            isPrimary={primaryGroup === "company"}
                            limit={8}
                            showRank={true}
                            count={groupings.company.totalCount}
                            onViewClick={onViewClickFor("author-company")}
                            onExportClick={onExportClickFor("author-company", exportUrlForCompany)}
                            rowLinkGenerator={companyWithinPortfolioLinkGenerator}
                            exploreUrl={exploreUrlForCompany}
                            exportUrl={exportUrlForCompany}
            />
        </ResponsiveLayoutItem>
    );

    const exploreUrlForAuthor = getExploreUrlFor("author");
    const exportUrlForAuthor = getExportUrlFor("author");
    const authorWidget = <ResponsiveLayoutItem>
        <GroupingWidget className="t-author-grouping"
                        currency={currency}
                        selectedKpi={rankingsSelectedKpi}
                        grouping={authorRanking}
                        title="Author"
                        limit={6}
                        showRank={true}
                        count={groupings.author.totalCount}
                        isPrimary={primaryGroup === "author"}
                        groupingName="author"
                        onViewClick={onViewClickFor("author")}
                        onExportClick={onExportClickFor("author", exportUrlForAuthor)}
                        exploreUrl={exploreUrlForAuthor}
                        exportUrl={exportUrlForAuthor}
        />
    </ResponsiveLayoutItem>;

    const additionalGroupingsSelectedKpi = kpiChooser.selectedKpi({isAdditionalGrouping: true});

    function createGroupingWidget(groupingName, showCount = true) {
        const grouping = groupings[groupingName];

        const title = formatGroupName(groupingName);
        const exploreUrlForGrouping = getExploreUrlFor(groupingName);
        const exportUrlForGrouping = getExportUrlFor(groupingName);

        return !showAdditionalGroupings ? null :
               <ResponsiveLayoutItem>
                   <GroupingWidget className={`t-${groupingName}-grouping`}
                                   currency={currency}
                                   selectedKpi={additionalGroupingsSelectedKpi}
                                   grouping={grouping ? grouping.results : null}
                                   groupingName={groupingName}
                                   title={title}
                                   count={grouping && showCount ? grouping.totalCount : null}
                                   onViewClick={onViewClickFor(groupingName)}
                                   onExportClick={onExportClickFor(groupingName, exportUrlForGrouping)}
                                   exploreUrl={exploreUrlForGrouping}
                                   exportUrl={exportUrlForGrouping}
                   />
               </ResponsiveLayoutItem>;
    }

    const sectorsWidget = createGroupingWidget("sector", false);
    const stockWidget = createGroupingWidget("organisation", true);
    const stockRegionWidget = createGroupingWidget("organisation-region", false);
    const authorRegionWidget = createGroupingWidget("author-region", false);
    const authorFunctionWidget = createGroupingWidget("author-function", false);
    const marketCapWidget = createGroupingWidget("market-cap", false);

    return (<ResponsiveLayout>
        {companyWidget}
        {authorWidget}
        {authorFunctionWidget}
        {authorRegionWidget}
        {stockWidget}
        {sectorsWidget}
        {stockRegionWidget}
        {marketCapWidget}
    </ResponsiveLayout>);
};

export default GroupingsLayout;